import React from 'react';

import { PlusIcon } from '@nw/shared/ui';

import { generateGoogleCalendarLink } from '../../utils/GoogleCalendarUtils';

import {
  CalendarInviteContainer,
  InviteButton,
  InviteCard,
  InviteText,
  InviteTextContainer
} from './styledComponents';
import { GoogleCalendarInviteComponentProps } from './types';

const GoogleCalendarInviteComponent: React.FC<
  GoogleCalendarInviteComponentProps
> = ({ selectADateToBookASlot, timeSlots, stepInfo }) => {
  const handleInviteClick = () => {
    try {
      const calendarLink = generateGoogleCalendarLink(
        selectADateToBookASlot,
        timeSlots
      );
      window.open(calendarLink, '_blank');
    } catch (error) {
      console.error('Failed to generate calendar link:', error);
    }
  };

  return (
    <CalendarInviteContainer>
      <InviteCard>
        <InviteTextContainer>
          <InviteText>
            Add to Google Calendar <br className="invite-text-break-line" /> so
            you don&apos;t miss out 😎
          </InviteText>
        </InviteTextContainer>
        <InviteButton
          id={stepInfo?.calendar_invite_cta_details?.btn_id}
          onClick={handleInviteClick}
        >
          <PlusIcon />
          Add to Calendar
        </InviteButton>
      </InviteCard>
    </CalendarInviteContainer>
  );
};

export { GoogleCalendarInviteComponent };
